import CONFIG from './Config.js'

export const Request = async (data, gateway) => {
    const myHeaders = new Headers();

    const token = localStorage.getItem("token") ?? false;
    if (typeof token !== "undefined" && token !== "undefined") {
        myHeaders.append("SupplierManagerToken", token);
    }

    const response = await fetch(
        CONFIG.API_GATE + gateway,
        {
            credentials: 'include',
            method: "POST",
            body: JSON.stringify(data),
            headers: myHeaders
        }
    );
    const responseJson = await response.json();

    /*
    console.log('#############################');
    console.log('         REQUEST:            ');
    console.log(data);
    console.log('          ANSWER:            ');
    console.log(responseJson);
    console.log('#############################');
    */

    if (responseJson.status.result === 'SUCCESS') {
        return responseJson.data;
    } else {
        return false;
    }
}

export const sendFileRequest = async (data, path) => {
    const myHeaders = new Headers();

    const token = localStorage.getItem("token") ?? false;
    if (typeof token !== "undefined" && token !== "undefined") {
        myHeaders.append("SupplierManagerToken", token);
    }

    let SEND_DATA = new FormData();

    for (let i in data) {
        if (typeof data[i] == 'object' && i !== 'image' && i !== 'file' && i !== 'passport_image' && i !== 'drivers_licence_image') {
            for (let j in data[i]) {

                let useField = data[i][j]
                if (useField === true) {
                    useField = 1
                } else if (useField === false) {
                    useField = 0
                }

                SEND_DATA.append(i + '[' + j + ']', useField);
            }
        } else if (typeof data[i] == 'array') {
            for (let j = 0; j < data[i].length; j++) {
                SEND_DATA.append(i + '[]', data[i][j]);
            }
        } else {
            SEND_DATA.append(i, data[i]);
        }
    }

    const response = await fetch(
        CONFIG.API_GATE + path,
        {
            credentials: 'include',
            method: "POST",
            headers: myHeaders,
            body: SEND_DATA
        },
    );
    const responseJSON = await response.json();

    if (responseJSON.status.result == 'ERROR') {
        const message = responseJSON.status.message ?? 'Произошла ошибка при выполнении запроса!';
        return false
    }

    return {
        status: true,
        data: responseJSON.data,
        message: responseJSON.status.message
    }
}
